import React, {ReactElement, useState} from 'react';
import SlideableSidePanel from "../../../components/slideableSidePanel/SlideableSidePanel";
import {useAppDispatch} from "../../../services/store/store";
import {handicaddieSelector} from "../../../services/store/asyncThunk";
import {
    handleCustomFromDateSelected,
    handleCustomToDateSelected,
    handleFilterCaddies,
    handleFilterSidePanelOpen,
    handlePresetDateFilterSelected,
    handleToggleCaddieFilter,
    handleToggleStarFilter
} from "../../../services/store/reducers/reviews/slice";
import {Form, Spinner} from 'react-bootstrap';
import StarIcon from "../../../icons/StarIcon";
import {IconSize} from "../../../services/IconConstants";
import Avatar from "../../../components/Avatar";
import {useDispatchedValue} from "../../../hooks/useDispatchedValue";

enum DateOptions {
    THIS_WEEK = 'This week',
    LAST_7_DAYS = 'Last 7 days',
    LAST_WEEK = 'Last week',
    THIS_MONTH = 'This month',
    LAST_31_DAYS = 'Last 31 days',
    LAST_MONTH = 'Last month',
    THIS_YEAR = 'This year',
    LAST_365_DAYS = 'Last 365 days',
    LAST_YEAR = 'Last year',
    CUSTOM = 'Custom'
}

interface Props {
}

const FilterSidePanel = ({}: Props) => {

    const dispatch = useAppDispatch();
    const { filterSidePanel, filters, caddies } = handicaddieSelector((state) => state.review)

    const [disableDatePicker, setDisableDatePicker] = useState<boolean>(true);

    const {value, setValue, processing} = useDispatchedValue((x) => dispatch(handleFilterCaddies(x)))

    const dateOptionSelect = (optStr: string) => {
        let opt = Object.values(DateOptions).find(o => o === optStr) as DateOptions | undefined
        if (!opt) {
            return;
        }

        if (DateOptions.CUSTOM === opt) {
            setDisableDatePicker(false);
            return;
        }

        setDisableDatePicker(true);
        let to = new Date()
        let from = new Date()

        let year = to.getFullYear()
        let mnth = to.getMonth()
        let day = to.getDay()

        to.getDay()

        switch (opt) {
            case DateOptions.THIS_WEEK:
                from.setTime(from.getTime() - ((day - 1) * 24 * 60 * 60 * 1000))
                to.setTime(from.getTime() + (7 * 24 * 60 * 60 * 1000))
                break;
            case DateOptions.LAST_7_DAYS:
                from.setTime(from.getTime() - (7 * 24 * 60 * 60 * 1000))
                break;
            case DateOptions.LAST_WEEK:
                from.setTime(from.getTime() - ((day - 1 + 7) * 24 * 60 * 60 * 1000))
                to.setTime(from.getTime() + (7 * 24 * 60 * 60 * 1000))
                break;
            case DateOptions.THIS_MONTH:
                from.setFullYear(year, mnth, 1)
                to.setFullYear(year, mnth + 1, 0)
                break;
            case DateOptions.LAST_31_DAYS:
                from.setTime(from.getTime() - (31 * 24 * 60 * 60 * 1000))
                break;
            case DateOptions.LAST_MONTH:
                from.setFullYear(from.getFullYear(), mnth - 1, 1)
                to.setFullYear(to.getFullYear(), mnth, 0)
                break;
            case DateOptions.THIS_YEAR:
                from.setFullYear(year, 0, 1)
                to.setFullYear(year + 1, 0, 0)
                break;
            case DateOptions.LAST_365_DAYS:
                from.setTime(from.getTime() - (365 * 24 * 60 * 60 * 1000))
                break;
            case DateOptions.LAST_YEAR:
                from.setFullYear(year - 1, 0, 1)
                to.setFullYear(year - 1, 11, 31)
                break;
        }

        dispatch(handlePresetDateFilterSelected({from, to}))
    }

    const stars = (count: number): ReactElement[] => {
        return [...Array(count)].map((_, idx) => {
            return <StarIcon key={count + "-" + idx} size={IconSize.sm} active={true} />
        })
    }

    return (
        <SlideableSidePanel width={25} open={filterSidePanel.open} handleClose={() => dispatch(handleFilterSidePanelOpen(false))}>
            <div className={"filter-side-panel"}>
                <div>
                    <h5 className={""}>Filter Reviews</h5>
                </div>

                <div>
                    <Form.Label column={'lg'}>Star Rating</Form.Label>
                    <Form.Group controlId="detailsForm.Stars">
                        <Form.Check
                            type="checkbox"
                            label={stars(5)}
                            checked={filters.stars.includes(5)}
                            onChange={() => dispatch(handleToggleStarFilter(5))} />
                        <Form.Check
                            type="checkbox"
                            label={stars(4)}
                            checked={filters.stars.includes(4)}
                            onChange={() => dispatch(handleToggleStarFilter(4))} />
                        <Form.Check
                            type="checkbox"
                            label={stars(3)}
                            checked={filters.stars.includes(3)}
                            onChange={() => dispatch(handleToggleStarFilter(3))} />
                        <Form.Check
                            type="checkbox"
                            label={stars(2)}
                            checked={filters.stars.includes(2)}
                            onChange={() => dispatch(handleToggleStarFilter(2))} />
                        <Form.Check
                            type="checkbox"
                            label={stars(1)}
                            checked={filters.stars.includes(1)}
                            onChange={() => dispatch(handleToggleStarFilter(1))} />
                    </Form.Group>
                </div>

                <div className={"filter-side-panel-section"}>
                    <Form.Label column={'lg'}>Dates</Form.Label>
                    <Form.Group controlId="detailsForm.Date">
                        <Form.Select className={"onboarding_input"}
                                     defaultValue={DateOptions.LAST_31_DAYS}
                                     onChange={x => dateOptionSelect(x.target.value)}>
                            {Object.values(DateOptions).map(opt => <option key={opt} value={opt}>
                                {opt}
                            </option>)}
                        </Form.Select>
                        <Form.Label column={'lg'} className={"filter-side-panel-dates-subheading"}>Custom From</Form.Label>
                        <Form.Control
                            type="date"
                            className="onboarding_input"
                            disabled={disableDatePicker}
                            onChange={x => dispatch(handleCustomFromDateSelected(x.target.value))}
                        />
                        <Form.Label column={'lg'} className={"filter-side-panel-dates-subheading"}>Custom To</Form.Label>
                        <Form.Control
                            type="date"
                            className="onboarding_input"
                            disabled={disableDatePicker}
                            onChange={x => dispatch(handleCustomToDateSelected(x.target.value))}
                        />

                    </Form.Group>
                </div>

                <div className={"filter-side-panel-section"}>
                    <Form.Label column={'lg'}>Caddie</Form.Label>
                    <Form.Group controlId="detailsForm.Caddie" className={"filter-side-panel-caddie-search"}>
                        <Form.Control
                            required
                            className="onboarding_input"
                            type="text"
                            name="caddie"
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                            placeholder="Search for a specific caddie..." />
                        {processing && <Spinner animation={'border'} className={"filter-side-panel-caddie-search-spinner"}/>}
                    </Form.Group>

                    <div className={"filter-side-panel-caddies"}>
                        {caddies.filtered.map((caddie) => (
                            <div className={"filter-side-panel-caddies-row"} key={caddie.caddieId}>
                                <Form.Check
                                    type="checkbox"
                                    checked={filters.caddie.map(c => c.caddieId).includes(caddie.caddieId)}
                                    onChange={() => dispatch(handleToggleCaddieFilter(caddie))} />
                                <Avatar size={'xs'} user={caddie.userId} />
                                <p>{caddie.displayName}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

        </SlideableSidePanel>
    )
}

export default FilterSidePanel;